import React from 'react';
import Address from "../../Components/Address/Address.jsx";
import { BarChartComponent } from '../../Components/Ui/BarChartComponent.jsx';
import "./WidgetsSales.scss";
import PiechartSales from '../../Components/Ui/Piechart-sales.jsx';
import RadialChartText from '../../Components/Ui/RadialChartText/RadialChartText.jsx';
import Barchart from '../../Components/Ui/Barchart.jsx';
import wallet from "../../Assets/wallet.png";

export default function WidgetsSales() {
  return (
    <div className="widgets-sales-container">
      <Address title="chart Graphs Sales" />
      <div className="widgets-row gap-2">
        <div className="widget-card shadow-sm rounded-3 p-3 bg-white">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Interaction rate</h5>
            <small className="text-muted">for September 2019</small>
          </div>
          <div className="progress-chart mb-4">
            <BarChartComponent />
          </div>

          <ul className="list-unstyled location-list">
            <li className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2">
                <div className="legend-icon blue-div"></div>
                <span>Saudia, Jedah</span>
              </div>
              <span className="fw-bold">81.57%</span>
            </li>
            <li className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2">
                <div className="legend-icon purple-div"></div>
                <span>Egypt, Cairo</span>
              </div>
              <span className="fw-bold">63.25%</span>
            </li>
            <li className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2">
                <div className="legend-icon yellow-div"></div>
                <span>Jordan, Oman</span>
              </div>
              <span className="fw-bold">52.95%</span>
            </li>
            <li className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-2">
                <div className="legend-icon green-div"></div>
                <span>Morocco, Casablanca</span>
              </div>
              <span className="fw-bold">47.29%</span>
            </li>
          </ul>
        </div>

    <div className="widget-card rounded-3 p-3 bg-white">
  <h5     style={{
      marginBottom:"30px"
    }} >Interaction rate</h5>

  <div className="d-flex flex-column gap-4">
    
    <div className="d-flex gap-4  align-items-start flex-wrap"
     style={{
      marginBottom:"100px"
    }}>
      <PiechartSales />

      <ul className="list-unstyled location-list mb-0">
        <li className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <div className="legend-icon blue-div"></div>
            <span>service 1</span>
          </div>
          <span className="fw-bold">81.57%</span>
        </li>
        <li className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <div className="legend-icon purple-div"></div>
            <span>service 2</span>
          </div>
          <span className="fw-bold">63.25%</span>
        </li>
        <li className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <div className="legend-icon yellow-div"></div>
            <span>service 3</span>
          </div>
          <span className="fw-bold">52.95%</span>
        </li>
        <li className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <div className="legend-icon green-div"></div>
            <span>service 4</span>
          </div>
          <span className="fw-bold">47.29%</span>
        </li>
        <li className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <div className="legend-icon blue-div"></div>
            <span>service 5</span>
          </div>
          <span className="fw-bold">81.57%</span>
        </li>
      </ul>
    </div>

 
    <div className="text-center">
      <RadialChartText />
    </div>
  </div>
</div>

<div className="transaction-card widget-card shadow-sm rounded-3 p-3 bg-white ">
  <div className="card-body">
    {[1, 2, 3,4].map((item, index) => (
      <div className="transaction-item" key={index}>
        <img src={wallet} width={40} height={40} alt="wallet" />
        <div className="transaction-info">
          <h6>Credit Card</h6>
          <span>11/02/2022</span>
        </div>
        <div className="transaction-amount">
          <h6>$129.95</h6>
          <button className="btn-details">Details</button>
        </div>
      </div>
    ))}
  </div>
</div>

      </div>


    


<div className="dashboard-flex">

  <div className="sales-chart">
    <div className="card">
      <h5>Sales</h5>
      <p>Every product</p>
      <div style={{ height: '300px' }}>
        <Barchart />
      </div>
    </div>
  </div>

  {/* Stock Summary */}
  <div className="stock-summary">
    <div className="header">
      <h4>Stock Summary</h4>
      <div className="legend">
        <div className="legend-item">
          <span className="color-box added"></span> Added Stock
        </div>
        <div className="legend-item">
          <span className="color-box available"></span> Available Stock
        </div>
      </div>
    </div>

    <div className="circles">
      <div className="circle">
        <svg width="80" height="80">
          <circle cx="40" cy="40" r="35" stroke="#00C49F" strokeWidth="5" fill="none" strokeDasharray="219.9" strokeDashoffset="43.98" />
          <text x="50%" y="50%" textAnchor="middle" dy=".3em" fontSize="18">80%</text>
        </svg>
      </div>
      <div className="circle">
        <svg width="80" height="80">
          <circle cx="40" cy="40" r="35" stroke="#FFBB28" strokeWidth="5" fill="none" strokeDasharray="219.9" strokeDashoffset="65.97" />
          <text x="50%" y="50%" textAnchor="middle" dy=".3em" fontSize="18">70%</text>
        </svg>
      </div>
    </div>

    <div className="low-stock">
      <p><strong>Low stock Products</strong></p>
      <ul>
        <li>Product name <span className="remaining">Remaining 10%</span></li>
        <li>Product name <span className="remaining">Remaining 25%</span></li>
        <li>Product name <span className="remaining">Remaining 33%</span></li>
        <li>Product name <span className="remaining">Remaining 35%</span></li>
      </ul>
    </div>
  </div>

  {/* Sales Card */}
  <div className="sales-box">
    <div className="sales-card">
      <div className="sales-header">
        <span>Sales #</span>
        <span className="arrow">⌄</span>
      </div>

      <div className="sales-value">
        <h2>$21,497.841</h2>
        <p className="increase">▲ 32% From Last Period</p>
      </div>

      <div className="progress-box">
        <div className="progress-line"></div>
        <span className="progress-value">688.75%</span>
      </div>
    </div>
  </div>
</div>

    </div>
  );
}